// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"e402950f","703":"65c7af84","787":"b37fdd72"}[chunkId] + ".chunk.js";
};